export default __webpack_public_path__ + "media/images/mastodon_small-ae4dc809b4dc9467b7eda440839b44be.jpg";